var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'progressbar',
    'd-flex',
    'align-items-center',
    _vm.getProgressbarClass,
  ]},[_c('span',{staticClass:"d-flex align-items-center",style:(_vm.getPercentageStyle)},[_c('span',{staticClass:"progressbar-percentage"},[_vm._v(_vm._s(_vm.percentage)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }